import React from 'react';

import _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { getValues } from 'redux-form';

import messages from './NoDirectorDetailsError.messages';
import InternalLink from '../../../../components/InternalLink';
import { buildApplicationState } from '../../../../helpers/applicationManager';
import { AUTOMATED_LENDING_DECISION_CHANGE_APPLICATION_STEP } from '../../AutomatedLendingDecision.actions';

const mapStateToProps = ({ fetched, form }) => {
    const formValues = getValues(form.sign_up);
    const state = buildApplicationState(
        fetched.application.payload,
        formValues
    );
    const applicant = _.find(state.people, (person) =>
        _.includes(person.roles, 'applicant')
    );
    return {
        customerName: `${applicant.first_name} ${applicant.last_name}`,
        companyName: state.company.company_name
    };
};

const mapDispatchToProps = (dispatch) => ({
    goToStep: (step) =>
        dispatch({
            type: AUTOMATED_LENDING_DECISION_CHANGE_APPLICATION_STEP,
            step
        })
});

class NoDirectorDetailsError extends React.Component {
    renderCheckDetailsLink = (step, name) => {
        const { goToStep } = this.props;
        return (
            <InternalLink onClick={() => goToStep(step)}>{name}</InternalLink>
        );
    };

    render() {
        const { customerName, companyName } = this.props;
        const checkNameDetailsLink = this.renderCheckDetailsLink(
            'personalInformation',
            customerName
        );
        const checkCompanyDetailsLink = this.renderCheckDetailsLink(
            'businessIntroduction',
            companyName
        );

        return (
            <div>
                <div className="title-text">
                    <FormattedMessage {...messages.title} />
                </div>

                <div className="content-text" data-testid="error-details-text">
                    <p>
                        <FormattedMessage {...messages.verifyIdentity} />
                    </p>
                    <p>
                        <FormattedMessage
                            {...messages.applicationDetailsCheck}
                            values={{
                                checkNameDetailsLink,
                                checkCompanyDetailsLink
                            }}
                        />
                    </p>
                </div>
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NoDirectorDetailsError);
